<div class="scroll-box">
  <div class="goal-grid">
    <div>
      <h4>What is the goal of your post?</h4>
    </div>
  </div>

  <form class="textarea" [formGroup]="workflowForm">
    <textarea
      formControlName="postGoal"
      placeholder="Write your post goal"
      maxlength="{{ postGoalMax }}"
    ></textarea>
    <span class="counter">{{ postGoalCount }}/{{ postGoalMax }}</span>
  </form>

  <div class="goal-subtext">
    <p>Suggested post goals based on your description:</p>
  </div>
  <form [formGroup]="workflowForm">
    <div
      *ngIf="workflowForm.get('postGoalSuggestions').value?.length"
      class="suggestions-buttons"
    >
      <ng-container
        *ngFor="
          let suggestion of workflowForm.get('postGoalSuggestions').value
            | jsonValueByKey: 'post_goals'
        "
      >
        <button class="suggestions-button" (click)="selectPostGoal(suggestion)">
          {{ suggestion }}
        </button>
      </ng-container>
    </div>
    <div
      *ngIf="!workflowForm.get('postGoalSuggestions').value?.length"
      class="no-suggestions"
    >
      No suggestions available.
    </div>
  </form>
</div>

<div class="btn-container">
  <button class="btn btn-primary" type="submit" (click)="askGenAi()">
    Next
  </button>
</div>
